import React, {ReactNode} from 'react';
import { ToggleSwitch } from '@pokemon/design.ui.input.toggle-switch'
import './permission-block.css'

export interface PermissionBlockProps extends React.HTMLProps<HTMLInputElement> {
  title: string,
  /**
    Can be text, or a ReactNode in case your description requires links or other non-text elements.
  */
  description: ReactNode | string | undefined,
  /**
    Oddly, is required to make toggle box work
  */
  id: string
};

export function PermissionBlock(props: PermissionBlockProps) {
  const { title, description, className, id, ...htmlProps } = props

  return (
    <div className={`permission-block ${className}`} {...htmlProps}>
      <div className="permission-block-top-bar">
        {title}
        <ToggleSwitch id={id} {...htmlProps}/>
      </div>
      <div className='permission-block-description'>
        {description}
      </div>
    </div>
  );
}